import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import routerBeforeAction from '@/utils/routerBeforeAction';
import {
  trackOutboundFunnel,
  flushOutboundAbandon,
  cancelOutboundAbandonWatch,
  type OutboundServiceGroup,
} from '@/utils/datadogOutboundFunnel';

import {
  routerHome,
  routerHelp,
  routerOutbound,
  routerTracking,
  routerMypage,
  routerSignin,
  routerSignup,
  routerOauth,
  routerSSO,
  routerCallback,
  routerService,
  routerBenefit,
  routerNotFound,
} from './children';

const routes: Array<RouteRecordRaw> = [
  routerHome,
  routerOutbound,
  routerTracking,
  routerHelp,
  routerMypage,
  routerSignin,
  routerSignup,
  routerOauth,
  routerSSO,
  routerCallback,
  routerService,
  routerBenefit,
  routerNotFound,
  {
    path: '/tradingStatement',
    name: 'router.tracking-trading-statement',
    component: () => import('@/views/TradingStatement.vue'),
  },
  {
    path: '/printAddress',
    name: 'router.tracking-print-address',
    component: () => import('@/views/PrintAddress.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// 라우터 변경 전 Action
routerBeforeAction(router);

/**
 * 주문접수 진입 라우트 → 접수구분 그룹.
 * 다량(mass-*)·완료(complete)·앱메뉴(app-menu)는 퍼널 진입 계측 대상이 아니다.
 */
const OUTBOUND_ENTER_ROUTE_GROUP: Record<string, OutboundServiceGroup> = {
  'router.outbound-quick': 'quick',
  'router.outbound-parcel': 'parcel',
  'router.outbound-registry': 'registry',
  'router.outbound-global': 'global',
};

router.afterEach((to) => {
  const serviceGroup = OUTBOUND_ENTER_ROUTE_GROUP[String(to.name)];

  // 접수 플로우 밖으로 벗어남.
  if (!serviceGroup) {
    // 주문완료 페이지 도달 = 성공 종료 → 이탈로 세지 않고 감시만 해제.
    // (order_success 누락 케이스에서도 완료가 abandon으로 오집계되지 않도록 명시적으로 처리)
    if (String(to.name) === 'router.outbound-complete') {
      cancelOutboundAbandonWatch();
      return;
    }
    // 그 외 이탈 → 도달 단계와 함께 기록. 활성 감시 없으면 no-op.
    flushOutboundAbandon('route', { nextPath: to.path });
    return;
  }

  // 퍼널 1단계(진입) 계측 — 진입 시점엔 세부 carrier/subtype이 미확정이라 serviceGroup만 전송
  trackOutboundFunnel('enter', { serviceGroup }, { once: true });
});

export default router;
